<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="liveId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播间连麦.直播间id')}}<template slot="title">{{$t('直播间连麦.直播间id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.liveId"  :placeholder="$t('通用.输入.请输入')+$t('直播间连麦.直播间id')" />
      </a-form-model-item>
      <a-form-model-item prop="liveUserId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播间连麦.直播间创建人')}}<template slot="title">{{$t('直播间连麦.直播间创建人')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.liveUserId"  :placeholder="$t('通用.输入.请输入')+$t('直播间连麦.直播间创建人')" />
      </a-form-model-item>
      <a-form-model-item prop="wheatType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播间连麦.连麦类型')}}<template slot="title">{{$t('直播间连麦.连麦类型')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="wheatStatus" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播间连麦.连麦状态')}}<template slot="title">{{$t('直播间连麦.连麦状态')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="muteStatus" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播间连麦.连麦静音状态')}}<template slot="title">{{$t('直播间连麦.连麦静音状态')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="cameraStatus" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播间连麦.摄像头状态0开1关')}}<template slot="title">{{$t('直播间连麦.摄像头状态0开1关')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="adminMuteStatus" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播间连麦.管理员连麦状态，0未静音，1已静音')}}<template slot="title">{{$t('直播间连麦.管理员连麦状态，0未静音，1已静音')}}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播间连麦.备注')}}<template slot="title">{{$t('直播间连麦.备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSeedingwheat, addSeedingwheat, updateSeedingwheat } from '@/api/live/seedingwheat'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        liveId: null,

        liveUserId: null,

        wheatType: null,

        wheatStatus: '0',

        muteStatus: '0',

        cameraStatus: '0',

        adminMuteStatus: '0',

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        liveId: null,
        liveUserId: null,
        wheatType: null,
        wheatStatus: '0',
        muteStatus: '0',
        cameraStatus: '0',
        adminMuteStatus: '0',
        createTime: null,
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSeedingwheat({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateSeedingwheat(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addSeedingwheat(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
